// extracted by mini-css-extract-plugin
export default {"link":"ProjectLinkField_link__3m7HP"};